import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
  connect() {
  }

  submit(event) {
    const form = event.currentTarget.closest('form');
    form.requestSubmit();
  }

  submitIfFileSelected(event) {
    const input = event.currentTarget;
    if (input.files && input.files.length > 0) {
      const form = input.closest('form');
      form.requestSubmit();
    }
  }
}
